import React from 'react'
import InstructorNavbar from '../components/instructor/InstructorNavbar'
import QuizInstructorResult from '../components/quiz/QuizInstructorResult'

const QuizInstructorResultPage = () => {
  return (
    <>
    <InstructorNavbar/>
    <QuizInstructorResult/>
    </>
  )
}

export default QuizInstructorResultPage